export enum CursorTypeEnum {
    default = 'default',
    action = 'action'
}